export default "__VITE_ASSET__C8lYUUqK__"